import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "kt_drawer_asset_info",
  "data-kt-drawer": "true",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-name": "edit_course",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_drawer_asset_info_button",
  "data-kt-drawer-close": "#kt_drawer_edit_course_close",
  "data-kt-drawer-width": "50.5vw"
}
const _hoisted_2 = {
  id: "kt_edit_course",
  class: "card shadow-none",
  style: {"width":"72.5vw"}
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header bg-success text-light\" id=\"kt_edit_course_header\"><h3 class=\"card-title fw-bolder text-light\" style=\"font-size:1.35rem !important;\"> Edit Asset Register </h3><div class=\"card-toolbar\"><button type=\"button\" class=\"btn btn-sm btn-icon btn-active-primary-light me-n5\" id=\"kt_drawer_edit_course_close\"><i class=\"fas fa-times text-light\"></i></button></div></div>", 1)
const _hoisted_4 = {
  class: "card-body position-relative",
  id: "kt_edit_course_body",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_edit_course_body",
  "data-kt-scroll-dependencies": "#kt_edit_course_header, #kt_edit_course_footer",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_5 = { class: "card mb-5 mb-xl-10" }
const _hoisted_6 = {
  id: "activity_report",
  class: "collapse show"
}
const _hoisted_7 = { class: "collapse show" }
const _hoisted_8 = { class: "card-body p-6" }
const _hoisted_9 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_10 = {
  id: "kt_info_update",
  class: "card shadow-none container-fluid px-0"
}
const _hoisted_11 = {
  class: "card-body position-relative",
  id: "kt_info_update_body",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_info_update_body",
  "data-kt-scroll-dependencies": "#kt_info_update_header, #kt_info_update_footer",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_12 = { class: "position-relative" }
const _hoisted_13 = { class: "scroll-y row" }
const _hoisted_14 = { class: "table table-row-dashed table-row-gray-600 align-middle gs-0 gy-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-dark" }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"150px"} }, " Supplier "),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"150px"} }, " Name of Asset "),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"150px","margin-top":"10px"} }, " Entry Date "),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"120px"} }, " Voucher Number "),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"120px"} }, " Value of Acquisition "),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"120px"} }, " Usefull Life "),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"120px"} }, " Identification No "),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"120px"} }, " Package No "),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"120px"} }, " Location "),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"120px"} }, " Opening Balance (Depreciation) "),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"120px"} }, " Opening WDV (Depreciation) "),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"120px"} }, " Rate in % (Depreciation) "),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"120px"} }, " Charged For The Period (Depreciation) "),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"120px"} }, " Balance End (Depreciation) "),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"120px"} }, " WDV wdv_end "),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"120px"} }, " Date and Remarks ")
  ])
], -1)
const _hoisted_16 = { class: "mt-3" }
const _hoisted_17 = {
  class: "card-footer py-5 text-left",
  id: "kt_info_update_footer"
}
const _hoisted_18 = { class: "svg-icon svg-icon-3 ms-2 me-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Form, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", null, [
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createVNode(_component_el_form, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("table", _hoisted_14, [
                                      _hoisted_15,
                                      _createElementVNode("tbody", null, [
                                        _createElementVNode("tr", null, [
                                          _createElementVNode("td", null, [
                                            _createVNode(_component_el_select, {
                                              class: "form-select-solid",
                                              placeholder: "Select Supplier",
                                              modelValue: _ctx.supplier,
                                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.supplier) = $event)),
                                              filterable: "",
                                              style: {"width":"100%"}
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suppliers, (data) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: data.id,
                                                    label: data.name,
                                                    value: data.id
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(data.name), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["label", "value"]))
                                                }), 128))
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue"])
                                          ]),
                                          _createElementVNode("td", null, [
                                            _withDirectives(_createElementVNode("input", {
                                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
                                              type: "text",
                                              class: "form-control form-control-sm",
                                              rows: "3"
                                            }, null, 512), [
                                              [_vModelText, _ctx.name]
                                            ])
                                          ]),
                                          _createElementVNode("td", null, [
                                            _createElementVNode("div", _hoisted_16, [
                                              _createVNode(_component_el_form_item, { prop: "start_date" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_date_picker, {
                                                    modelValue: _ctx.entry_date,
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.entry_date) = $event)),
                                                    "value-format": "YYYY-MM-DD",
                                                    format: "DD-MM-YYYY",
                                                    style: {"width":"100%","margin-top":"13px"},
                                                    type: "date",
                                                    name: "start_date"
                                                  }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              })
                                            ])
                                          ]),
                                          _createElementVNode("td", null, [
                                            _withDirectives(_createElementVNode("input", {
                                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.file_no) = $event)),
                                              type: "text",
                                              class: "form-control form-control-sm",
                                              rows: "3"
                                            }, null, 512), [
                                              [_vModelText, _ctx.file_no]
                                            ])
                                          ]),
                                          _createElementVNode("td", null, [
                                            _withDirectives(_createElementVNode("input", {
                                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.value_acquisition) = $event)),
                                              type: "number",
                                              class: "form-control form-control-sm",
                                              rows: "3"
                                            }, null, 512), [
                                              [_vModelText, _ctx.value_acquisition]
                                            ])
                                          ]),
                                          _createElementVNode("td", null, [
                                            _withDirectives(_createElementVNode("input", {
                                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.usefull_of_life) = $event)),
                                              type: "text",
                                              class: "form-control form-control-sm",
                                              rows: "3"
                                            }, null, 512), [
                                              [_vModelText, _ctx.usefull_of_life]
                                            ])
                                          ]),
                                          _createElementVNode("td", null, [
                                            _withDirectives(_createElementVNode("input", {
                                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.identification) = $event)),
                                              type: "text",
                                              class: "form-control form-control-sm",
                                              rows: "3"
                                            }, null, 512), [
                                              [_vModelText, _ctx.identification]
                                            ])
                                          ]),
                                          _createElementVNode("td", null, [
                                            _withDirectives(_createElementVNode("input", {
                                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.package) = $event)),
                                              type: "text",
                                              class: "form-control form-control-sm",
                                              rows: "3"
                                            }, null, 512), [
                                              [_vModelText, _ctx.package]
                                            ])
                                          ]),
                                          _createElementVNode("td", null, [
                                            _withDirectives(_createElementVNode("input", {
                                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.location) = $event)),
                                              type: "text",
                                              class: "form-control form-control-sm",
                                              rows: "3"
                                            }, null, 512), [
                                              [_vModelText, _ctx.location]
                                            ])
                                          ]),
                                          _createElementVNode("td", null, [
                                            _withDirectives(_createElementVNode("input", {
                                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.opening_balance) = $event)),
                                              type: "number",
                                              class: "form-control form-control-sm",
                                              rows: "3"
                                            }, null, 512), [
                                              [_vModelText, _ctx.opening_balance]
                                            ])
                                          ]),
                                          _createElementVNode("td", null, [
                                            _withDirectives(_createElementVNode("input", {
                                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.opening_wdv) = $event)),
                                              type: "number",
                                              class: "form-control form-control-sm",
                                              rows: "3"
                                            }, null, 512), [
                                              [_vModelText, _ctx.opening_wdv]
                                            ])
                                          ]),
                                          _createElementVNode("td", null, [
                                            _withDirectives(_createElementVNode("input", {
                                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.rate_in) = $event)),
                                              type: "text",
                                              class: "form-control form-control-sm",
                                              rows: "3"
                                            }, null, 512), [
                                              [_vModelText, _ctx.rate_in]
                                            ])
                                          ]),
                                          _createElementVNode("td", null, [
                                            _withDirectives(_createElementVNode("input", {
                                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.charged_period) = $event)),
                                              onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.calculateWDV())),
                                              type: "number",
                                              class: "form-control form-control-sm",
                                              rows: "3"
                                            }, null, 544), [
                                              [_vModelText, _ctx.charged_period]
                                            ])
                                          ]),
                                          _createElementVNode("td", null, [
                                            _withDirectives(_createElementVNode("input", {
                                              disabled: "",
                                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.balance) = $event)),
                                              type: "number",
                                              class: "form-control form-control-sm",
                                              rows: "3"
                                            }, null, 512), [
                                              [_vModelText, _ctx.balance]
                                            ])
                                          ]),
                                          _createElementVNode("td", null, [
                                            _withDirectives(_createElementVNode("input", {
                                              disabled: "",
                                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.wdv_end) = $event)),
                                              type: "number",
                                              class: "form-control form-control-sm",
                                              rows: "3"
                                            }, null, 512), [
                                              [_vModelText, _ctx.wdv_end]
                                            ])
                                          ]),
                                          _createElementVNode("td", null, [
                                            _withDirectives(_createElementVNode("input", {
                                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.remarks) = $event)),
                                              type: "text",
                                              class: "form-control form-control-sm",
                                              rows: "3"
                                            }, null, 512), [
                                              [_vModelText, _ctx.remarks]
                                            ])
                                          ])
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_17, [
                                    _createElementVNode("button", {
                                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.formSubmit())),
                                      type: "button",
                                      class: "btn btn-success mr-3 p-3",
                                      style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                                    }, [
                                      _createTextVNode(" Update "),
                                      _createElementVNode("span", _hoisted_18, [
                                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                                      ])
                                    ])
                                  ])), [
                                    [_directive_loading, _ctx.load]
                                  ])
                                ]),
                                _: 1
                              })
                            ])
                          ])), [
                            [_directive_loading, _ctx.load]
                          ])
                        ])), [
                          [_directive_loading, _ctx.loading]
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}